import $ from "jquery";
window.$ = window.jQuery = $;

import "jquery-validation/dist/jquery.validate.min.js";

import "stylesheets/application.scss";

const images = require.context('../images', true);
const imagePath = (name) => images(name, true);
